import { ApiResponse, ApiResponseError } from "./types";

export const api = async <T = any, E = ApiResponseError>(
  url: string,
  options?: RequestInit
): Promise<ApiResponse<T, E>> => {
  let data: T | undefined = undefined;
  let error: E | undefined = undefined;
  let response: Response;
  try {
    response = await fetch(url, options);
  } catch (e) {
    type ErrorType = { status: number; message: string };
    response = new Response(null, {
      status: (e as ErrorType).status,
      statusText: (e as ErrorType).message,
    }) as Response;
  }
  if (response.ok) {
    try {
      data = (await response.json()) as T;
    } catch {
      // No response data
    }
  } else {
    data = {} as T;
    try {
      error = (await response.json()) as E;
    } catch {
      // No response data
    }
  }
  return {
    ...response,
    ok: response.ok,
    status: response.status,
    json: () => data || error,
    data,
    error,
  } as ApiResponse<T, E>;
};
